import React, { InputHTMLAttributes, forwardRef } from 'react';
import { cn } from '../../lib/utils';
import PhoneInput2 from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
  error?: boolean;
  type?: string;
  onPhoneChange?: (value: string) => void;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, icon, error, type, onPhoneChange, ...props }, ref) => {
    if (type === 'tel') {
      return (
        <div className="relative">
          <PhoneInput2
            country="fr"
            value={props.value as string}
            onChange={(value) => onPhoneChange?.(value)}
            containerClass={cn(
              "react-tel-input",
              error && "phone-input-error"
            )}
            inputClass={cn(
              "form-control",
              className
            )}
            specialLabel=""
            enableSearch
            disableSearchIcon
            searchPlaceholder="Rechercher un pays..."
            searchNotFound="Aucun résultat"
            preferredCountries={['fr', 'be', 'ch', 'lu']}
            localization={{
              fr: 'France',
              be: 'Belgique',
              ch: 'Suisse',
              lu: 'Luxembourg'
            }}
          />
          {icon && (
            <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
              {icon}
            </div>
          )}
        </div>
      );
    }

    return (
      <div className="relative">
        {icon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
            {icon}
          </div>
        )}
        <input
          className={cn(
            "w-full rounded-lg border transition-all duration-200",
            "focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500",
            icon ? "pl-10" : "pl-3",
            error
              ? "border-red-300 bg-red-50 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500"
              : "border-gray-300 bg-white placeholder-gray-400",
            className
          )}
          ref={ref}
          type={type}
          {...props}
        />
      </div>
    );
  }
);

Input.displayName = "Input";

export { Input };